<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'FORMADESEMBOLSO.LBL_ESPECIES' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioEstado" name="nomFormularioEstado">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'FORMADESEMBOLSO.LBL_TIPOESPECIE' | translate }}</label>
            <p-dropdown disableTab  id="idEspecie" name="nomEspecie" [options]="lisFormaDesembolso"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idFormaDesembolso"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFormaDesembolso.invalid">
              {{ 'FORMADESEMBOLSO.LBL_TIPOESPECIE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <button class="p-button-datatables" icon="fa fa-plus"
                  label="{{'BTN_AGREGAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas"
                 [value]="lisProductoFormaDesembolso" selectionMode="single" dataKey="idProductoFormaDesembolso"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.formaDesembolso}}</td>
              <td>{{row.porcentaje}}%</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-cog" data-toggle="tooltip"
                          title="{{'BTN_CONFIGURAR' | translate}}" pButton *ngIf="row.codigoFormaDesembolso==='CONV'"
                          (click)="configurar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="forma-desembolso">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>


<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [(visible)]="verPcfdModal"
          [contentStyle]="{'width':'1000px'}"
          header="{{ 'FORMADESEMBOLSO.LBL_CONFIGURACIONCONVENIOS' | translate}}"
          [modal]="true">

  <app-producto-forma-desembolso-convenio #pfdc (alRegresar)="verDatatable($event)"></app-producto-forma-desembolso-convenio>

</p-dialog>

